import styles from 'css/src/components/common/ui/Select/FormatGroupLabel.module.scss';

import React from 'react';
import type { GroupBase } from 'react-select';

import type { SelectOption } from './types';

/**
 * Component for group label headers
 */
export default function formatGroupLabel(data: GroupBase<SelectOption>) {
    return (
        <div className={styles['custom-select-format-group-label']}>
            <span>{data.label}</span>
        </div>
    );
}
